
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateResponse} from './ConfigUpdateResponse';
import {FieldModelConfigUpdateResponse} from './ConfigUpdateResponse';
import {CurrencyGroup} from '../core/CurrencyGroup';
import {FieldModelCurrencyGroup} from '../core/CurrencyGroup';

/**
 * CurrencyGroupCreateResponse struct
 */
class CurrencyGroupCreateResponse extends ConfigUpdateResponse {
  /**
   * Initialize struct
   * @param {!ConfigUpdateResponse=} parent
   * @param {!CurrencyGroup=} currencyGroup
   * @constructor
   */
  constructor (parent = new ConfigUpdateResponse(), currencyGroup = new CurrencyGroup()) {
    super()
    super.copy(parent)
    this.CurrencyGroup = currencyGroup
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CurrencyGroupCreateResponse}
   * @param {!CurrencyGroupCreateResponse} other Other struct
   * @returns {!CurrencyGroupCreateResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.CurrencyGroup != null) {
      this.CurrencyGroup = CurrencyGroup.fromObject(other.CurrencyGroup)
    } else {
      this.CurrencyGroup = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CurrencyGroupCreateResponse}
   * @returns {!CurrencyGroupCreateResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CurrencyGroupCreateResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CurrencyGroupCreateResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CurrencyGroupCreateResponse}
   * @param {!CurrencyGroupCreateResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CurrencyGroupCreateResponse)) {
      throw new TypeError('Instance of CurrencyGroupCreateResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CurrencyGroupCreateResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      CurrencyGroup: ((this.CurrencyGroup != null) ? this.CurrencyGroup : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CurrencyGroupCreateResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CurrencyGroupCreateResponse} other Object value
   * @returns {!CurrencyGroupCreateResponse} Created struct
   */
  static fromObject (other) {
    return new CurrencyGroupCreateResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CurrencyGroupCreateResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CurrencyGroupCreateResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CurrencyGroupCreateResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6079
  }
}

export { CurrencyGroupCreateResponse };

/**
 * Fast Binary Encoding CurrencyGroupCreateResponse field model
 */
class FieldModelCurrencyGroupCreateResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateResponse(buffer, 4 + 4)
    this.CurrencyGroup = new FieldModelCurrencyGroup(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the ConfigUpdateResponse field model
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!FieldModelConfigUpdateResponse} ConfigUpdateResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.CurrencyGroup.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.CurrencyGroup.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCurrencyGroupCreateResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6079
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CurrencyGroup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroup.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!CurrencyGroupCreateResponse} fbeValue Default value, defaults is new CurrencyGroupCreateResponse()
   * @returns {!CurrencyGroupCreateResponse} CurrencyGroupCreateResponse value
   */
  get (fbeValue = new CurrencyGroupCreateResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!CurrencyGroupCreateResponse} fbeValue CurrencyGroupCreateResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroup.fbeSize) <= fbeStructSize) {
      fbeValue.CurrencyGroup = this.CurrencyGroup.get()
    } else {
      fbeValue.CurrencyGroup = new CurrencyGroup()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroup.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {!CurrencyGroupCreateResponse} fbeValue CurrencyGroupCreateResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCurrencyGroupCreateResponse}
   * @param {CurrencyGroupCreateResponse} fbeValue CurrencyGroupCreateResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.CurrencyGroup.set(fbeValue.CurrencyGroup)
  }
}

export { FieldModelCurrencyGroupCreateResponse };

/**
 * Fast Binary Encoding CurrencyGroupCreateResponse model
 */
class CurrencyGroupCreateResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCurrencyGroupCreateResponse(this.buffer, 4)
  }

  /**
   * Get the CurrencyGroupCreateResponse model
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!FieldModelCurrencyGroupCreateResponse} model CurrencyGroupCreateResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CurrencyGroupCreateResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCurrencyGroupCreateResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CurrencyGroupCreateResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CurrencyGroupCreateResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CurrencyGroupCreateResponseModel}
   * @param {!CurrencyGroupCreateResponse} value CurrencyGroupCreateResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CurrencyGroupCreateResponseModel}
   * @param {!CurrencyGroupCreateResponse} value CurrencyGroupCreateResponse value, defaults is new CurrencyGroupCreateResponse()
   * @return {!object} Deserialized CurrencyGroupCreateResponse value and its size
   */
  deserialize (value = new CurrencyGroupCreateResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CurrencyGroupCreateResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CurrencyGroupCreateResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CurrencyGroupCreateResponseModel}
   * @param {!number} prev Previous CurrencyGroupCreateResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CurrencyGroupCreateResponseModel };
